/* Update date: 09-06-2023
 * Popup select store component
 */
import { DataGridFull } from 'app/components/DataGrid';
import { Button, Popup, TextBox, ScrollView } from 'devextreme-react';
import React, { useState, useRef, useEffect } from 'react';
import useAxios from 'axios-hooks';
import { USER_STORE_URL } from 'constant/apiUrl';
import useFormatTime from 'hooks/useFormatTime';
import useDictionary from 'hooks/useDictionary';
import { isMobile } from 'react-device-detect';
import LoadPanel from 'app/components/LoadPanel';
import { useApp } from 'app';
interface PopupSelectMultiProps {
  visible?: boolean;
  onHiding?: () => void;
  text?: string;
  onSubmit: (selected: any) => void;
  mode?: 'single' | 'multiple';
  bodyData?: any;
}

const PopupSelectStore = (props: PopupSelectMultiProps) => {
  const {
    visible,
    onHiding,
    text,
    onSubmit,
    mode = 'single',
    bodyData = {},
  } = props;
  const { themePro }: any = useApp();
  const [name, setName] = useState<any>(text);
  const dataRef: any = useRef(null);
  const { DateTimeFormat } = useFormatTime();
  const { t } = useDictionary({});

  const [{ data: listData, loading }, fetchStoreByName] = useAxios(
    {
      url: USER_STORE_URL,
      method: 'POST',
    },
    {
      manual: true,
      useCache: false,
      autoCancel: true,
    },
  );

  /**
   * on search
   *
   */
  const onSearch = () => {
    fetchStoreByName({
      data: {
        ...bodyData,
        storeName: name,
        storeType: [],
        use: [true],
        representative: '',
        ids: [],
        ascending: true,
      },
    });
  };

  /**
   * on ok
   *
   */
  const onOk = () => {
    const selectedRowKeys =
      dataRef?.current?.instance?.option?.()?.selectedRowKeys;
    if (!mode || mode === 'single') {
      const d = selectedRowKeys?.[0];
      onSubmit(d);
    }
    if (mode === 'multiple') {
      onSubmit(selectedRowKeys);
    }
  };

  useEffect(() => {
    onSearch();
  }, [name]);

  /**
   * render content
   *
   * @return {*}
   */
  const content = () => {
    return (
      <ScrollView width="100%" height="100%">
        <div style={{ padding: '0 15px' }}>
          <LoadPanel visible={loading} />
          {themePro && (
            <div className="modal-popup-header">
              <span className="title-page">{t('Store')}</span>
              <div>
                <Button
                  stylingMode="contained"
                  type="default"
                  text={t('OK')}
                  icon="check"
                  style={{ marginRight: 5 }}
                  onClick={onOk}
                />
                <Button
                  stylingMode="contained"
                  text={t('Cancel')}
                  icon="close"
                  onClick={onHiding}
                />
              </div>
            </div>
          )}
          <div
            style={
              themePro
                ? {
                    padding: 8,
                    backgroundColor: '#fff',
                    borderRadius: 6,
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                    boxShadow:
                      '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
                  }
                : {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: 20,
                  }
            }
          >
            <TextBox
              width={themePro ? 400 : '40vw'}
              defaultValue={name}
              onValueChanged={e => setName(e?.value)}
              onEnterKey={onSearch}
              style={{ marginRight: 10 }}
            />
            <Button icon="search" text={t('Search')} onClick={onSearch} />
          </div>
          <DataGridFull
            ref={dataRef}
            dataSource={listData?.data}
            fixedLeft={0}
            fixedRight={0}
            columns={[
              {
                dataField: 'storeNo',
                caption: t('Store ID'),
                visible: false,
                alignment: 'left',
              },
              {
                dataField: 'storeTpName',
                caption: t('Store Type'),
              },
              {
                dataField: 'bussinessNumber',
                caption: t('Business Number'),
              },
              {
                dataField: 'storeNm',
                caption: t('Store'),
              },
              {
                dataField: 'representative',
                caption: t('Representative'),
              },
              {
                dataField: 'email',
                caption: t('Email'),
              },
              {
                dataField: 'mobile',
                caption: t('Mobile No'),
              },
              {
                dataField: 'phone',
                caption: t('Phone no'),
              },
              {
                dataField: 'createdDate',
                caption: t('Regist date time'),
                alignment: 'left',
                dataType: 'date',
                format: DateTimeFormat,
              },
            ]}
            options={{
              onRowDblClick: onOk,
              onToolbarPreparing: (e: any) => {
                e.toolbarOptions.items.unshift({
                  location: 'before',
                  template: 'totalCount',
                });
              },
              selection: {
                mode,
                selectAllMode: 'allPages',
              },
              height: themePro
                ? 'calc(100vh - 200px)'
                : isMobile
                ? 'calc(80vh - 200px)'
                : 'calc(70vh - 200px)',
              columnAutoWidth: true,
            }}
          />
          {!themePro && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 20,
              }}
            >
              <Button icon="save" text={t('OK')} onClick={onOk} />
              <Button icon="close" text={t('Cancel')} onClick={onHiding} />
            </div>
          )}
        </div>
      </ScrollView>
    );
  };

  return (
    <Popup
      className="modal-content-popup"
      visible={visible}
      onHiding={onHiding}
      title={t('Store')}
      contentRender={content}
      height={themePro ? '100vh' : isMobile ? '80vh' : '70vh'}
      width={isMobile ? '96%' : '60vw'}
      position={{
        boundaryOffset: { x: undefined, y: 50 },
      }}
    />
  );
};

export default PopupSelectStore;
